<template>
  <div>
    <v-sheet class="pt-2 px-1" style="background-color: transparent;">
      <v-layout align-center justify-center v-if="subCategories.length > 0">
        <v-flex v-if="subCategories.length > 0">
           <OwlCarousel :nav="false" :dots="true" :responsive="owlResponsive" class="subcategory-carousel">
            <template v-for="(item, i) in subCategories">
              <v-flex px-1 :key="i" @click="changeRoute(item)">
                <v-layout wrap justify-center style="position: relative; margin-bottom: 12px; cursor: pointer;" class="category-item">
                  <v-flex xs12 class="d-flex justify-center" style="position: relative;">
                    <div style="position: relative; display: inline-block;">
                      <div 
                        class="category-ring"
                        :style="($route.query.SubCategory == item.urlname) ? 'border-color: #3EA56E;' : 'border-color: #e2e8f0;'" 
                        style="border-style: solid; border-width: 2px; border-radius: 50%; padding: 2px; width: 70px; height: 70px; display: flex; align-items: center; justify-content: center; background-color: #ffffff; transition: all 0.3s ease;">
                        <v-avatar size="62" style="background-color: #f8fafc;">
                          <v-img cover :src="mediaURLOld + item.icon">
                            <template v-slot:placeholder>
                              <div class="img-shimmer"></div>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="text-center mt-3 px-2">
                    <span
                      style="
                        font-family: 'Poppins', sans-serif;
                        font-weight: 700;
                        font-size: 10px;
                        color: #1e293b;
                        letter-spacing: 0.5px;
                        text-transform: uppercase;
                        display: block;
                        line-height: 1.4;
                        transition: color 0.3s ease;
                      "
                      :style="($route.query.SubCategory == item.urlname) ? 'color: #3EA56E;' : ''"
                    >
                      {{ item.name }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </OwlCarousel>
        </v-flex>
      </v-layout>
    </v-sheet>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      subCategories: [],
      owlResponsive: {
        0: { items: 3, nav: false },
        600: { items: 5, nav: false },
        960: { items: 6, nav: false },
        1264: { items: 8, nav: false },
        mainCategoryId: null,
        categoryId: null,
        subCategoryId: null,
        SubCategory: null,
      },
    };
  },
  beforeMount() {
    this.SubCategory = this.$route.query.SubCategory;
    this.getSubCategory();
    this.mainCategoryId = this.mainCat;
    this.categoryId = this.getCat;
    this.subCategoryId = this.getSubCat;
  },

  computed: {
    mainCat() {
      return this.$store.state.SelectedIDS.MainCatId;
    },
    getCat() {
      return this.$store.state.SelectedIDS.CatId;
    },
    getSubCat() {
      return this.$store.state.SelectedIDS.SubId;
    },
  },
  methods: {
    getSubCategory() {
      this.appLoading = true;

      axios({
        method: "get",
        url: "/subcategory/getlist/single",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          maincategoryname: this.$route.params.MainCategory,
          categoryname: this.$route.query.Category,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.subCategories = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    changeRoute(item) {
      if (item) {
        localStorage.setItem("subCategoryId", item._id);
        this.$store.commit("updateSubCatId", item._id);
        
        this.$router.push({
          path: "/products/" + (this.$route.params.MainCategory || ''),
          query: {
            Category: this.$route.query.Category,
            SubCategory: item.urlname,
          },
        });
        this.SubCategory = this.$route.query.SubCategory;
      }
    },
  },
};
</script>
<style scoped>
.owl-buttons {
  display: none;
}

.owl-carousel:hover .owl-buttons {
  display: block;
}

/* Shimmer skeleton loader for subcategory icons */
.img-shimmer {
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    #e8e8e8 25%,
    #f5f5f5 50%,
    #e8e8e8 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  border-radius: 50%;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.category-item:hover .category-ring {
  border-color: #3EA56E !important;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.15);
}

.category-item:hover span {
  color: #3EA56E !important;
}
</style>